import apiClient, { unwrap } from './client'
import type { RetentionPolicy } from './types'

export type RetentionPolicyInput = Omit<RetentionPolicy, 'updated_at'>

export const retentionApi = {
  get() {
    return unwrap<RetentionPolicy>(apiClient.get('/retention'))
  },
  put(input: RetentionPolicyInput) {
    return unwrap<RetentionPolicy>(apiClient.put('/retention', input))
  },
}